import { useState } from 'react';
import DatePicker from 'react-datepicker';
import ReactTooltip from 'react-tooltip';
import Text from '../../../atoms/Text';

import 'react-datepicker/dist/react-datepicker.css';

interface IDateParamFieldProps {
  title: string;
  value: Date | null;
  minDate?: Date | null;
  placeholder?: string;
  isError?: boolean;
  onSave(date: Date | null): void;
  formatValue?(value: number): string;
  validateValue?(value: number): boolean;
  getTooltip?(): JSX.Element;
}

const DateParamField = ({
  title,
  value,
  minDate,
  placeholder,
  isError,
  onSave,
  getTooltip,
}: IDateParamFieldProps) => {
  const [focused, setFocused] = useState(false);

  return (
    <div className='params_panel__param params_panel__param--editable'>
      <div className='params_panel__param__property'>
        <Text size={12}>{title}</Text>
        {getTooltip && (
          <div
            data-tip={`${title} tooltip`}
            data-for={title}
            className='params_panel__param__property__icon icon-tooltip-circle'
          />
        )}
      </div>
      {getTooltip && (
        <ReactTooltip
          id={title}
          effect='solid'
          place='left'
          className='graph_tooltip__box'
          getContent={getTooltip}
        />
      )}
      <div
        className={`input_wrapper params_panel__param__date_picker ${
          isError ? 'input_wrapper--error' : ''
        }`}
      >
        <DatePicker
          selected={value}
          onChange={onSave}
          placeholderText={focused ? '' : placeholder}
          showTimeSelect
          showIcon
          className='input_wrapper__editable text--14'
          minDate={minDate}
          dateFormat='dd.MM.yy HH:mm:ss'
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        />
      </div>
    </div>
  );
};

export default DateParamField;
